import layoutBlocks from "../partials/layout-blocks";
import configPage from "../partials/config-page";
import seo from '../partials/seo';

function page (lang) {
    return {
        file: `site/content/_index.${lang}.md`,
        label: `Home Page ${lang}`,
        name: `home_${lang}`,
        ...configPage,
        fields: [
            {label: 'Title', name: 'title', widget: 'string', i18n: true},
            {label: 'Body', name: 'body', widget: 'markdown', i18n: true},
            ...seo
        ]
    }
}

export default page
